import { ChevronLeft } from 'assets/icons';
import Button from 'components/button';

/** The company the mission is for, the screen it is on, and the way back. */
const TemplateScreenTitle = ({ overline, title, onBack, backLabel }) => (
  <div className="flex items-center gap-3">
    {onBack ? (
      <Button size="ICON" color="SECONDARY" onClick={onBack}>
        <span className="sr-only">{backLabel}</span>
        <span aria-hidden="true">
          <ChevronLeft wh={18} color="#374151" />
        </span>
      </Button>
    ) : null}
    <div className="flex flex-col min-w-0">
      {overline ? (
        <span className="ft-sm text-gray-500 uppercase truncate">
          {overline}
        </span>
      ) : null}
      <span className="ft-xl font-medium text-gray-900 truncate">{title}</span>
    </div>
  </div>
);

export default TemplateScreenTitle;
